import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getRobotsContentForPath } from "./seoConstants";

/** Sets `<meta name="robots">` from the current route. */
const RouteRobotsMeta = () => {
  const { pathname } = useLocation();
  const content = useMemo(() => getRobotsContentForPath(pathname), [pathname]);

  return (
    <Helmet>
      <meta name="robots" content={content} />
    </Helmet>
  );
};

export default RouteRobotsMeta;
